import React, { useState } from "react"
import { CustomModalBox } from "../../components/modal/CustomModalBox"
import { Form, Button, Spinner } from "react-bootstrap"
import { CustomInput } from "../../components/custom-input/CustomInput"
import { useDispatch, useSelector } from "react-redux"
import { newLeadAction } from "../../pages/lead/leadAction"

const initialState = {
  fName: "",
  lName: "",
  phone: "",
  email: "",
  location: "",
  note: "",
}

export const LeadForm = ({ setShowForm }) => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)

  const params = new URLSearchParams()
  params.set("branch", user?.branch)
  const par = params.toString()

  const [studentLead, setStudentLead] = useState(initialState)
  const { isLoading } = useSelector((state) => state.studentLead)

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setStudentLead({
      ...studentLead,
      [name]: value,
    })
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()
    dispatch(newLeadAction({ ...studentLead, params: par }))
    setStudentLead(initialState)
    setShowForm(false)
  }

  const inputFields = [
    {
      name: "fName",
      type: "text",
      label: "First Name",
      placeholder: "First Name",
      value: studentLead.fName,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "lName",
      type: "text",
      label: "Last Name",
      placeholder: "Last Name",
      value: studentLead.lName,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "phone",
      type: "number",
      label: "phone Number",
      placeholder: "Student's phone number",
      value: studentLead.phone,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "email",
      type: "email",
      label: "Email",
      autoComplete: "email",
      placeholder: "Student's@email",
      value: studentLead.email,
      required: true,
      onChange: handleOnChange,
    },

    {
      name: "note",
      type: "text",
      as: "textarea",
      label: "note",
      placeholder: "...",
      value: studentLead.note,
      onChange: handleOnChange,
    },
  ]

  return (
    <CustomModalBox title="Create new student lead">
      {isLoading && <Spinner variant="primary" animation="border" />}

      {
        //use toaster for the response
      }
      <Form onSubmit={handleOnSubmit}>
        {inputFields.map((attributes, i) => (
          <CustomInput key={i} {...attributes} />
        ))}
        <Form.Group className="mt-3">
          <Form.Label>Location</Form.Label>
          <Form.Select
            name="location"
            value={studentLead.location}
            onChange={handleOnChange}
          >
            <option value={0}>-- Select location --</option>
            <option value="sydney">Sydney</option>
            <option value="canberra">Canberra</option>
          </Form.Select>
        </Form.Group>

        <div className="d-grid py-3">
          <Button type="submit">Submit</Button>
        </div>
      </Form>
    </CustomModalBox>
  )
}
